import { useEffect } from "react";

import ResetPasswordView from "../../sections/reset-password/view";

const ResetPasswordPage = () => {
  useEffect(() => {
    document.body.classList.add("login");
    return () => {
      document.body.classList.remove("login");
    };
  }, []);

  return <ResetPasswordView />;
};

export default ResetPasswordPage;
